import React, { Component } from "react";
import PropTypes from "prop-types";
import "./Gallery.css";

class Gallery extends Component {
  constructor(props) {
    super(props);
    this.keyDown = this.keyDown.bind(this);
    this.state = {
      show: props.show,
      activeImage: 0,
      images: []
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      images: nextProps.data,
      show: nextProps.show
    });
  }

  getActiveImage() {
    console.log('getActiveImage -> line 24: ', this.state.images[this.state.activeImage]);
    let activeImage = (
      <img
        className="image-slider__image"
        key={this.state.activeImage}
        src={`${process.env.REACT_APP_IMG_SERVER}/${
          this.state.images[this.state.activeImage]
        }`}
        alt=""
      />
    );
    return activeImage;
  }

  handleSlide(direction) {
    let currentIndex = this.state.activeImage;
    if (direction === "prev") {
      --currentIndex;
      if (currentIndex < 0) {
        currentIndex = this.state.images.length - 1;
      }
    } else if (direction === "next") {
      ++currentIndex;
      if (currentIndex > this.state.images.length - 1) {
        currentIndex = 0;
      }
    }

    this.setState({
      activeImage: currentIndex
    });
  }

  keyDown(e) {
    switch (e.keyCode) {
      case 39:
        return this.handleSlide("next");

      case 37:
        return this.handleSlide("prev");

      case 27:
        return this.props.hideGallery();

      default:
        return;
    }
  }

  render() {
    if (!this.state.images || !this.props.show) {
      return null;
    }

    let currentImage = this.getActiveImage();

    return (
      <div className="image-slider">
        <div className="image-slider__container">
          <button
            className="image-slider__close"
            onClick={this.props.hideGallery}
          />
          {currentImage}
          <div className="image-slider__controls">
            <button
              onKeyDown={e => this.keyDown(e)}
              className="image-slider__control image-slider__control--prev"
              onClick={this.handleSlide.bind(this, "prev")}
            />
            <button
              autoFocus
              tabIndex="0"
              onKeyDown={e => this.keyDown(e)}
              className="image-slider__control image-slider__control--next"
              onClick={this.handleSlide.bind(this, "next")}
            />
          </div>
          <div className="image-slider__description">
            <h1>{this.props.name}</h1>
            <p
              dangerouslySetInnerHTML={{
                __html: this.props.address
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

Gallery.propTypes = {
  data: PropTypes.array,
  show: PropTypes.bool,
  name: PropTypes.string,
  address: PropTypes.string,
  hideGallery: PropTypes.func
};

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/Gallery/Gallery.js